import React from 'react';
import styles from '../../styles/BuildingPreviews/RoommateGroupActions.module.css';

const RoommateGroupActions = ({ roommateStatuses, onSuggestToGroup, onRequestTour }) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>👥 Roommate Activity</h3>
      This is for Demonstration. <br/>Real Data will come later.<br/>
      <div className={styles.statusList}>
        {roommateStatuses.map(({ name, status, date }) => (
          <div
            key={name}
            className={`${styles.statusItem} ${
              status === 'liked' ? styles.statusLiked : styles.statusPending
            }`}
          >
            {status === 'liked' ? `${name} liked this (${date})` : `${name} hasn't responded`}
          </div>
        ))}
      </div>

      <div className={styles.actionsRow}>
        <button
          className={`${styles.actionBtn} ${styles.primaryActionBtn}`}
          onClick={onSuggestToGroup}
        >
          👍 Suggest to Group
        </button>
        <button
          className={styles.actionBtn}
          onClick={onRequestTour}
        >
          📅 Request Tour
        </button>
      </div>
    </div>
  );
};

export default RoommateGroupActions;
